import axiosPrivate from "@services/axiosPrivate";

export const upgradeDoctorAccess = (updateObject) => {
  return axiosPrivate.post(`/updatePostPayDoctorAccess`, updateObject);
};
